import { useNavigate } from 'react-router-dom';

export default function DeclarationSection() {
  const navigate = useNavigate();

  return (
    <section id="declaration" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Nanum Myeongjo', serif" }}>
            사법정의를 위한 청년 선언
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-t-4 border-red-600">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              대한민국의 헌정 질서가 중대한 위협에 직면해 있습니다.
              지난 2026년 2월 11일 밤, 국회 법제사법위원회에서 집권 여당의 주도로 대한민국의 사법 체계를 근본적으로 뒤흔드는 세 가지 법안이 통과되었습니다. 저들은 이를 '3대 사법개혁법안'이라 부르며 포장하고 있으나, 그 실상은 사법부의 독립성을 훼손하고 삼권분립의 헌정 질서를 파괴하는 <strong className="text-red-600">'3대 사법장악 법안'</strong>에 다름없습니다.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4 flex items-center">
              <span className="w-10 h-10 bg-red-600 text-white rounded-full flex items-center justify-center mr-3 text-lg">1</span>
              헌법재판소법 개정안 (재판소원법)
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              대법원에서 최종 확정된 판결에 대해서도 헌법재판소에 다시 헌법소원을 제기할 수 있도록 하는 내용입니다. 이는 사실상의 <strong>'4심제'</strong>를 도입하여 헌법이 정한 권력분립 원칙을 정면으로 무너뜨리는 것입니다.
            </p>
            <p className="text-sm text-gray-600 bg-gray-50 p-4 rounded-lg mb-6">
              <i className="ri-alert-line text-red-600 mr-2"></i>
              기우종 법원행정처 차장: "재판소원 도입은 헌법 개정 사항이며 법률 개정만으로 도입할 수는 없어 도저히 받아들일 수 없다"
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4 flex items-center">
              <span className="w-10 h-10 bg-red-600 text-white rounded-full flex items-center justify-center mr-3 text-lg">2</span>
              법원조직법 개정안 (대법관 증원법)
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              현재 14명인 대법관을 26명으로 두 배 가까이 대폭 증원하는 내용입니다. 이 법이 본회의를 통과할 경우, 현 대통령은 임기 중 무려 <strong className="text-red-600">22명의 대법관</strong>을 임명하게 됩니다. 특정 정권이 최고법관의 압도적 다수를 독식하는 것은, 과거 우고 차베스 정권이 대법관 12명을 증원하여 사법부를 완전히 장악하고 베네수엘라를 독재 국가로 몰아넣었던 참담한 전철을 그대로 밟는 것입니다.
            </p>
            <p className="text-sm text-gray-600 bg-gray-50 p-4 rounded-lg mb-6">
              <i className="ri-alert-line text-red-600 mr-2"></i>
              늘어난 대법관 12명을 보좌할 재판연구관을 최소 24명에서 최대 101명까지 일선 법원에서 차출해야 하며, 이는 1심과 2심 재판의 심각한 지연과 부실을 초래합니다.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4 flex items-center">
              <span className="w-10 h-10 bg-red-600 text-white rounded-full flex items-center justify-center mr-3 text-lg">3</span>
              형법 개정안 (법왜곡죄)
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              판사와 검사가 법을 잘못 적용했다고 판단될 경우 <strong className="text-red-600">10년 이하의 징역</strong>에 처할 수 있도록 하는 법안입니다. '법을 잘못 적용했다'는 주관적이고 모호한 기준을 들어 판사를 형사 처벌하겠다는 것은 명백한 사법부 겁박입니다.
            </p>
            <p className="text-sm text-gray-600 bg-gray-50 p-4 rounded-lg mb-6">
              <i className="ri-alert-line text-red-600 mr-2"></i>
              천대엽 전 법원행정처장: "심판을 심판하겠다는 법" - 판사들은 소신 있는 판결을 내리지 못한 채 대법원 판례만을 기계적으로 답습할 것
            </p>

            <div className="bg-red-50 border-l-4 border-red-600 p-6 my-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">우리의 요구와 결단</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mr-3 mt-1"></i>
                  <span>국회는 삼권분립을 파괴하는 「헌법재판소법 개정안」, 「법원조직법 개정안」, 「형법 개정안」을 즉각 폐기하라.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mr-3 mt-1"></i>
                  <span>정치권은 당리당략으로 사법제도를 훼손하는 입법 독주를 즉각 중단하라.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mr-3 mt-1"></i>
                  <span>헌법이 명시한 사법부의 독립과 공정한 재판을 받을 국민의 권리를 철저히 보장하라.</span>
                </li>
              </ul>
            </div>

            <blockquote className="border-l-4 border-gray-300 pl-6 py-4 my-8 italic text-gray-600">
              "의를 위하여 박해를 받은 자는 복이 있나니 천국이 그들의 것임이라"<br />
              <span className="text-sm">- 마태복음 5:10</span>
            </blockquote>

            <p className="text-gray-700 leading-relaxed font-semibold text-lg">
              우리는 이 불의한 독재 법안들이 철회되고 이 땅의 정의가 온전히 회복될 때까지, 범국민적 연대와 저항 운동을 강력히 전개해 나갈 것을 엄숙히 선언합니다.
            </p>

            <div className="text-center mt-12 pt-8 border-t-2 border-gray-200">
              <p className="text-gray-600 mb-2">2026년 2월 17일</p>
              <p className="text-xl font-bold text-gray-900 mb-6">발기인 및 공동 선언인 120명 일동</p>
              
              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-xs text-gray-600 leading-relaxed">
                  강가은 · 구윤서 · 권세인 · 고선우 · 김기홍 · 김다은 · 김단비 · 김도현 · 김민서 · 김민선 · 김민주 · 김민지 · 김수진 · 김수현 · 김시은 · 김예원 · 김예은 · 김영범 · 김은선 · 김은영 · 김은혁 · 김정운 · 김정직 · 김지민 · 김지현 · 김찬영 · 김찬진 · 김태준 · 김택원 · 김하늘 · 김하은 · 김하진 · 김하진 · 김호윤 · 김화연 · 김희석 · 김희원 · 남윤희 · 단진형 · 류솔비 · 민상운 · 박결 · 박성아 · 박성훈 · 박수인 · 박준민 · 박진혁 · 박찬일 · 박형빈 · 박효진 · 배상현 · 배성민 · 배희재 · 백승리 · 변지혜 · 방의석 · 서빛나 · 성소연 · 성인영 · 송가람 · 송경배 · 송수민 · 신상규 · 신영은 · 심예현 · 심혜림 · 심혜미 · 엄민지 · 오상덕 · 오승종 · 오승환 · 오해성 · 오현교 · 윤기연 · 윤여민 · 윤진 · 이강희 · 이건희 · 이기세 · 이동찬 · 이상협 · 이선행 · 이선희 · 이수연 · 이수현 · 이아영 · 이예림 · 이유민 · 이윤석 · 이은지 · 이요섭 · 이재범 · 이재훈 · 이종혁 · 이지선 · 이지원 · 이하림 · 임유진 · 장시온 · 전지현 · 정예안 · 정예진 · 정주영 · 정한나 · 지승호 · 조서진 · 조용철 · 조준경 · 천웅진 · 최강호 · 최소영 · 최승현 · 최예나 · 최윤서 · 한정무 · 허예준 · 허충범 · 현예원 · 홍상현 · 황영현
                </p>
                <p className="text-xs text-gray-400 mt-2">(가나다 순서 120명)</p>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="https://aidkbfywmirotpuhmlid.supabase.co/storage/v1/object/public/downloads/Declare_100justice.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-red-600 text-white rounded-full text-sm font-semibold hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-file-text-line text-base"></i>
                  </span>
                  선언문 전문보기 (PDF)
                </a>
                <button
                  onClick={() => navigate('/sign')}
                  className="inline-flex items-center gap-2 px-8 py-3 bg-gray-900 text-white rounded-full text-sm font-semibold hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-pen-nib-line text-base"></i>
                  </span>
                  지금 바로 서명하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
